import theme from '@styles/theme';
export default {
  section: {
    background: '#111',
    p: ['48px 16px 0', '48px 16px 0', '80px 16px 0', '80px 16px 0', '60px 24px 0']
  },
  container: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: ['column-reverse', 'column-reverse', 'column-reverse', 'column-reverse', 'row'],
    justifyContent: 'space-around',
    maxWidth: '1920px',
    width: '100%',
    margin: '0 auto'
  },
  video: {
    position: 'relative',
    width: ['100%', '100%', '100%', '100%', '753px'],
    height: ['336px', '336px', '700px', '700px', 'auto']
  },
  playerIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: '0.8',
    zIndex: theme.zIndex.documentUp,
    '&:hover': {
      opacity: 1
    },
    ':after': {
      content: '""',
      borderStyle: 'solid',
      borderWidth: '15px 0 15px 25px',
      borderColor: 'transparent transparent transparent #000000',
      position: 'absolute',
      top: 'calc(50% + 1px)',
      left: 'calc(50% + 3px)',
      transform: 'translate(-50%, -50%) rotate(-1deg)',
      zIndex: '0'
    }
  },
  descriptionWrapper: {
    width: ['100%', '100%', '479px', '479px', '467px'],
    margin: ['0 auto', '0 auto', '0 auto', '0 auto', 0],
    position: 'relative',
    color: theme.rawColors.neutralWhite,
    maxWidth: ['100%', '100%', '100%', '48%'],
    textAlign: ['center', 'center', 'center', 'center', 'left'],
    height: ['auto', 'auto', 'auto', 'auto', 734],
    pb: ['24px', '24px', '24px', '24px', 0],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '.description-vr': {
      lineHeight: '140%',
      padding: ['16px 0 0', '16px 0 0', '32px 45px 5px', '32px 0 5px'],
      textAlign: ['center', 'center', 'center', 'center', 'left']
    }
  },
  mapBox: {
    display: 'flex',
    marginBottom: ['0', '0', '30px'],
    alignItems: ['left', 'left', 'center', 'left'],
    justifyContent: ['center', 'center', 'center', 'center', 'left'],
    '.description-map': {
      width: '130px',
      margin: '25px 12px',
      padding: '32px 0 5px',
      textAlign: 'left'
    }
  }
};